"use client"

// Importing icons from lucide-react
import { ChevronsLeft } from "lucide-react"
import { useEffect, useState } from "react"
import { useNavigate, useLocation, Link } from "react-router-dom"
import { useSelector } from "react-redux"
import ShieldIconSvg from "../assets/svg/ShieldIconSvg"

// Sidebar component
function Sidebar() {
  // Hook for navigation (react-router)
  const navigate = useNavigate()

  // Get the current mode (private or normal) from Redux store
  const mode = useSelector(state => state.mode.mode)

  // Active view state (which menu item is currently active)
  const [activeView, setActiveView] = useState("wallets")

  // Hook to get current location (URL path)
  const location = useLocation()

  // Update activeView when the URL path changes
  useEffect(() => {
    const path = location.pathname

    if (path === "/dashboard" || path === "/dashboard/") {
      setActiveView("wallets")
    } else if (path === "/dashboard/activity") {
      setActiveView("activity")
    } else if (path === "/dashboard/nfts") {
      setActiveView("nfts")
    } else if (path === "/dashboard/dapps") {
      setActiveView("dapps")
    } else if (path === "/dashboard/settings") {
      setActiveView("settings")
    } else if (path === "/on-ramping") {
      setActiveView("on-ramping")
    } else if (path === "/off-ramping") {
      setActiveView("off-ramping")
    } else if (path === "/user-sessions") {
      setActiveView("user-sessions")
    } else if (path === "/rango-exchange") {
      setActiveView("rango-exchange")
    } else {
      setActiveView("wallets")
    }

    console.log("Active view set to:", activeView)
  }, [location.pathname])

  // Sidebar menu items
  const menuItems = [
    {
      id: "wallets",
      label: "PiggyBank",
      icon: (
        <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 39" width="28" height="22">
          <g id="Layer 3">
          </g>
          <g id="Layer 2">
            <g>
              <path fill="currentColor" d="m2.91 14.43q0.01-0.03 0 0z" />
              <path fill="currentColor" d="m2.45 17.27c0 0.02 0 0.04 0 0z" />
              <path fill="currentColor" d="m15.6 19.38l7.44-13.31c-2.56-0.75-5.15-0.95-7.57-0.7z" />
              <path fill="currentColor" d="m40.65 15.29c-0.4-0.79-1.41-0.96-2.22-1.32-1.04-0.47-1.04-0.37-2.37-1.48-0.94-0.78-1.22-1.52-1.84-2.15-0.73-0.73-1.77-1.53-1.77-1.53 0 0 0.07-0.55 0.62-1.87 0.56-1.32 1.12-2.47-0.06-2.43-1.32 0.04-3.8 1.62-5.88 3.21l-6.4 12.01 5.47 7.68c0 0 0.22 2.88 0.36 4.13 0.09 0.95 0.75 0.9 1.1 0.9 0.34 0 0.69 0 1.32 0 0.62 0 0.76-0.49 0.91-1.04 0.14-0.54 1.2-4.91 1.2-4.91 0 0 1.83-1.37 2.74-2.25 0.88-0.84 1.81-2.25 3.42-3.31 0 0 1.41-0.97 2.27-1.57 0.47-0.32 0.74-0.64 1.03-1.16 0.38-0.7 0.51-2.11 0.1-2.91z" />
              <path fill="currentColor" d="m15.52 20.25l0.05 7.82c2.01 0.15 4.12 0.07 5.93-0.07z" />
              <path fill="currentColor" d="m5.04 10.48c-1.07 1.37-1.74 2.7-2.13 3.95q-0.01 0.04 0 0c-0.52-0.17-1.28-0.39-1.72-0.4-0.43-0.01-1.05 0.54-0.53 1.41 0.4 0.68 0.69 1.05 1.79 1.83 0-0.01 0-0.03 0 0-0.04 3.49 1.83 5.84 1.83 5.84 0 0 2.35 6.18 2.83 7.84 0.46 1.59 0.89 1.49 1.75 1.49 1.08 0 1.42 0.04 1.53-0.81 0.22-1.44 0.2-2.49 0.41-4.56l-0.05-20.6c-2.38 0.92-4.38 2.3-5.71 4.01z" />
            </g>
          </g>
        </svg>
      ),
      path: "/dashboard",
      forPrivate: true,
    },
    {
      id: "tour-history-swap-link",
      label: "Swap",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2" d="m16 3l4 4l-4 4m4-4H4m4 14l-4-4l4-4m-4 4h16" /></svg>
      ),
      path: "/rango-exchange",
      forPrivate: false,
    },
    {
      id: "tour-buy-container",
      label: "Buy",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3"><circle cx="8" cy="21" r="1" /><circle cx="19" cy="21" r="1" /><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" /></g></svg>
      ),
      path: "/on-ramping",
      forPrivate: false,
    },
    {
      id: "tour-sell-aside-link",
      label: "Sell",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 2v20m5-17H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" /></svg>
      ),
      path: "/off-ramping",
      forPrivate: false,
    },
    {
      id: "tour-history-aside-link",
      label: "History",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="M5.636 18.364A9 9 0 1 0 3 12.004V14" /><path d="m1 12l2 2l2-2m6-4v5h5" /></g></svg>
      ),
      path: "/history",
      forPrivate: true,
    },
  ]

  // Function to handle navigation
  const handleNavigation = (path) => {
    // Remove sidebar class from body when navigating
    document.querySelector("body").classList.remove("show-aside")
    navigate(path)
  }

  // Check if the current path is active
  const isActive = (path) => {
    return location.pathname === path
  }

  return (
    <div className="sidebar">
      {/* Sidebar Header */}
      <div className="sidebar-header flex items-center justify-between">
        <div className="logo">
          <a href="https://kaxaa.com" rel="noopener noreferrer">
            <img width="190" src="/assets/kax-logo.svg" alt="kax-logo" />
          </a>
        </div>
        {/* Toggle button for small screens */}
        <div
          className="lg:hidden cursor-pointer p-2 sider-toggle"
          onClick={() => document.querySelector("body").classList.toggle("show-aside")}
        >
          <ChevronsLeft />
        </div>
      </div>

      {/* Sidebar Menu Items */}
      <nav className="sidebar-nav mt-4 relative">
        {menuItems.map((item) => {
          // Hide non-private items when mode = private
          if (mode === "private" && !item.forPrivate) {
            return null
          }
          return (
            <button
              key={item.path}
              id={item.id}
              onClick={() => handleNavigation(item.path)}
              className={`nav-item ${isActive(item.path) ? "active" : ""}`}
            >
              <span className="nav-icon flex justify-center" style={{ minWidth: "32px" }}>{item.icon}</span>
              {item.label}
            </button>
          )
        })}

        {/* Show private mode indicator */}
        {mode === "private" && (
          <div className="private-mode-on">
            <ShieldIconSvg />
            Private mode
          </div>
        )}
      </nav>

      {/* Sidebar Footer (Settings link) */}
      {/* <div className="sidebar-footer">
        <button
          onClick={() => handleNavigation("/dashboard/settings")}
          className={`nav-item ${isActive("/dashboard/settings") ? "active" : ""}`}
        >
          <span className="nav-icon"><Settings size="19" /></span>
          Settings
        </button>
      </div> */}
    </div>
  )
}

export default Sidebar
